import { ThemeContext, type Theme } from '@/contexts/theme.context'
import { useThemeOverride } from '@/utils/theme-override'
import * as React from 'react'

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [theme, setTheme] = React.useState<Theme>(() => {
    if (typeof window !== 'undefined') {
      return (localStorage.getItem('theme') as Theme) || 'dark'
    }
    return 'dark'
  })
  const themeOverride = useThemeOverride()
  const activeTheme = themeOverride ?? theme

  React.useEffect(() => {
    const root = window.document.documentElement

    root.classList.remove('light', 'dark')

    root.classList.add(activeTheme)
  }, [activeTheme])

  const handleThemeChange = (newTheme: Theme) => {
    setTheme(newTheme)
    localStorage.setItem('theme', newTheme)
  }

  return (
    <ThemeContext.Provider value={{ theme: activeTheme, setTheme: handleThemeChange }}>
      {children}
    </ThemeContext.Provider>
  )
}
